export { default } from './SweetAlert';



// WEBPACK FOOTER //
// ./src/design-system/atoms/SweetAlert/index.jsx